"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
// coingecko has priority over debank for initialized tokens
const coingecko_ids = {
    //Polygon
    "0x40379a439d4f6795b6fc9aa5687db461677a2dba": "real-usd",
    "0x00e8c0e92eb3ad88189e7125ec8825edc03ab265": "wrapped-usdr",
    "0x49e6a20f1bbdfeec2a8222e052000bbb14ee6007": "tangible",
    "0x7238390d5f6f64e67c3211c343a410e2a3dec142": "pearl",
    "0x6ae96cc93331c19148541d4d2f31363684917092": "caviar",
    // Arbitrum
    "0xb348b87b23d5977e2948e6f36ca07e1ec94d7328": "swapfish",
    "0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f": "wrapped-bitcoin",
    "0x463913d3a3d3d291667d53b8325c598eb88d3b0e": "solidlizard",
    "0xaaa6c1e32c55a7bfa8066a6fae9b42650f262418": "ramses-exchange",
    "0xd5954c3084a1ccd70b4da011e67760b8e78aee84": "arbitrum-exchange",
    "0xff191514a9baba76bfd19e3943a4d37e8ec9a111": "auragi",
    "0x15b2fb8f08e4ac1ce019eadae02ee92aedf06851": "chronos-finance",
    "0xaae0c3856e665ff9b3e2872b6d75939d810b7e40": "yieldfarming-index",
    "0xe80772eaf6e2e18b651f160bc9158b2a5cafca65": "usd",
    // Avalanche
    "0x3712871408a829c5cd4e86da1f4ce727efcd28f6": "glacier",
    // ZkSync
    "0x503234f203fc7eb888eec8513210612a43cf6115": "liquity-usd",
    "0x85d84c774cf8e9ff85342684b0e795df72a24908": "velocore",
    "0x5756a28e2aae01f600fc2c01358395f5c1f8ad3a": "vesync",
    "0x160e07e42adbc1fce92d505b579bcd8a3fbea77d": "dracula-fi",
    // Scroll
    "0x1a2fcb585b327fadec91f55d45829472b15f17a4": "tokan",
    "0x188b158caf5ea252012dbd6030afc030329c4961": "zen",
    "0xf610a9dfb7c89644979b4a0f27063e9e7d7cda32": "wrapped-steth",
    "0xa25b25548b4c98b0c7d3d27dca5d5ca743d68b7f": "wrapped-rseth",
    "0x80137510979822322193fc997d400d5a6c747bf7": "stakestone-ether",
    "0x2b6a85cd35d15691357eea61d88cb3f401a92fc3": "surveyor-dao",
    "0x7dbd14115baf4240aab8c4ef31bf71f76c708420": "uk-real-estate",
    "0x25ea98ac87a38142561ea70143fd44c4772a16b6": "stack-2",
    "0xd29687c813d741e2f938f4ac377128810e217b1b": "scroll",
    // base
    "0x940181a94a35a4569e4529a3cdfb74e38fd98631": "aerodrome-finance",
    "0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed": "degen-base",
    "0x4200000000000000000000000000000000000006": "ethereum",
    "0x54016a4848a38f257b6e96331f7404073fd9c32c": "equalizer-base",
    "0xa3d1a8deb97b111454b294e2324efad13a9d8396": "overnight-finance",
    "0x4154550f4db74dc38d1fe98e1f3f28ed6dad627d": "jarvis-synthetic-euro",
    "0xa61beb4a3d02decb01039e378237032b351125b4": "eura",
    "0x7002458b1df59eccb57387bc79ffc7c29e22e6f7": "origin-protocol",
    "0xdbfefd2e8460a6ee4955a68582f85708baea60a3": "super-oeth",
    "0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf": "coinbase-wrapped-btc",
    "0x576bca23dcb6d94ff8e537d88b0d3e1bead444a2": "base-carbon-tonne",
    "0x36912b5cf63e509f18e53ac98b3012fa79e77bf5": "fuego",
    "0x9b8df6e244526ab5f6e6400d331db28c8fdddb55": "wrapped-solana-universal",
    // optimism
    "0x9560e827af36c94d2ac33a39bce1fe78631088db": "velodrome-finance",
    "0x4200000000000000000000000000000000000042": "optimism",
    "0x1f32b1c2345538c0c6f582fcb022739c4a194ebb": "wrapped-steth",
    "0x55027a5b06f4340cc4c82dcc74c90ca93dcb173e": "tadpole",
    // re.al
    "0xce1581d7b4ba40176f0e219b2cac30088ad50c7a": "pearl",
    "0xb785ee8752b8bf3b0c8d9857f24b491e8c0a3d92": "coinbase-wrapped-btc",
    // blast
    "0x52f847356b38720b55ee18cb3e094ca11c85a192": "fenix",
    // sonic
    "0x3333b97138d4b086720b5ae8a7844b1345a33333": "shadow-2",
    // linea
    "0x894134a25a5fac1c2c26f1d8fbf05111a3cb9487": "grai"
};
const dexscreener_ids = {
    // ibex on scroll
    "0x78ab77f7d590fb101aa18affc238cbfea31ead5b": "scroll",
    // ibex on polygon
    "0xf972daced7c6b03223710c11413036d17eb298f6": "polygon",
    // ibex on arb
    "0x56659245931cb6920e39c189d2a0e7dd0da2d57b": "arbitrum",
    // ibex on zksync
    "0xbe9f8c0d6f0fd7e46cdacca340747ea2f247991d": "zksync",
    // preon on scroll
    "0x135f9b3d5dec9d73c042cf380adfff95f4fe9e35": "scroll,blast",
    // wstRWA on scroll
    "0x154f5db4950d2cd4a7af425e11865215f90ddb07": "scroll",
    // axlOP on base
    "0x994ac01750047B9d35431a7Ae4Ed312ee955E030": "base",
    // opxvelo on op
    "0xc38464250f51123078bbd7ea574e185f6623d037": "optimism",
    // fantom-bomb on scroll (removed from coingecko)
    "0x6b6882f7642ee1c15f12b51f1a4988b3e7e29f5c": "scroll",
};
const fantom_ids = {
    // uponly on ftm
    "0x28f1d1c509495e5afc23fb47acf6cc5b217ab598": "fantom",
    // plus-bet on ftm
    "0x39551b1c26ce03714e4661833b0fa730174bd7e9": "fantom",
    // tango on ftm
    "0xee9ff3efd508741492b5bd45269aa45a43be59c8": "fantom",
    // fantomsonicinu
    "0x05e31a691405d06708a355c029599c12d5da8b28": "fantom",
    //sonic goat
    "0x43f9a13675e352154f745d6402e853fecc388aa5": "fantom",
    // fantom eco
    "0xb8a32897016c1b2ee0797090162eafe58f032795": "fantom",
    // hoops
    "0x431516e478d73cfab034229c4d7a94a2cbf5787f": "fantom",
    // moon bay on ftm
    "0xd361474bb19c8b98870bb67f5759cdf277dee7f9": "fantom",
    // thc on fantom
    "0x479673391b3818f5e3ed2fa69a58e13d685becf6": "fantom",
    // equal
    "0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6": "equalizer-dex",
    // wftm
    "0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83": "wrapped-fantom",
    // mftm
    "0x62227c75908b7d358a9d70ea4670f57f8b012ccc": "fantom",
    // fiery
    "0xc36cae799b758d04dac9b3a1fd59755c4a8ae721": "fantom",
    // Skitty
    "0xad531012c0651a85a212f10fc97b3ec15684548a": "fantom",
    // fBomb
    "0x74ccbe53f77b08632ce0cb91d3a545bf6b8e0979": "fantom",
    // mclb
    "0x5deb27e51dbeef691ba1175a2e563870499c2acb": "fantom",
    // hedgy
    "0x16c22105301cfd85fd0f911920d282d18cc175c1": "fantom"
};
class OffchainPriceHelper {
    ;
    constructor(offchain) {
        this.coingeckoInitialized = null;
        this.offchain = offchain;
        this.debankTokensPrice = {};
    }
    cleanCache() {
        this.subgraphTokensPrice = null;
        this.debankTokensPrice = {};
    }
    // First source of token price: Offchain (less accurate, faster)
    addPriceIfMissing(offchainTokenPrice, token) {
        if (offchainTokenPrice[token.id])
            return;
        offchainTokenPrice[token.id] = parseFloat(token.derivedUSD);
    }
    initializeSubgraphTokenPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolsData = yield this.offchain.getLendingPoolsData();
            const offchainTokenPrice = {};
            for (const factory in lendingPoolsData) {
                for (const id in lendingPoolsData[factory]) {
                    const lendingPool = lendingPoolsData[factory][id];
                    this.addPriceIfMissing(offchainTokenPrice, lendingPool.borrowable0.underlying);
                    this.addPriceIfMissing(offchainTokenPrice, lendingPool.borrowable1.underlying);
                    for (const reward of lendingPool.pair.rewards) {
                        this.addPriceIfMissing(offchainTokenPrice, reward.rewardsToken);
                    }
                }
            }
            //fix for IMX
            offchainTokenPrice["0x9c67ee39e3c4954396b9142010653f17257dd39c"] = 0;
            offchainTokenPrice["0x7b35ce522cb72e4077baeb96cb923a5529764a00"] = 0;
            offchainTokenPrice["0xea6887e4a9cda1b77e70129e5fba830cdb5cddef"] = 0;
            offchainTokenPrice["0x60bb3d364b765c497c8ce50ae0ae3f0882c5bd05"] = 0;
            offchainTokenPrice["0x900f1ec5819fa087d368877cd03b265bf1802667"] = 0;
            offchainTokenPrice["0xea38f1ccf77bf43f352636241b05dd8f6f5f52b2"] = 0;
            offchainTokenPrice["0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83"] = 0;
            offchainTokenPrice["0xc19669a405067927865b40ea045a2baabbbe57f5"] = 0;
            offchainTokenPrice["0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6"] = 0;
            //offchainTokenPrice["0xad531012c0651a85a212f10fc97b3ec15684548a"] = 0;
            return offchainTokenPrice;
        });
    }
    getSubgraphTokensPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.subgraphTokensPrice)
                this.subgraphTokensPrice = this.initializeSubgraphTokenPrice();
            return this.subgraphTokensPrice;
        });
    }
    getAllCoingeckoPrices() {
        return __awaiter(this, void 0, void 0, function* () {
            // Remove duplicates just in case, get the unique coingecko token ids
            const tokenIds = Object.values(coingecko_ids);
            const uniqueIds = [...new Set(tokenIds)].join(",");
            try {
                // Get all token prices from gecko
                const response = yield fetch("https://api.coingecko.com/api/v3/simple/price?ids=" + uniqueIds + "&vs_currencies=usd");
                if (response.status != 200)
                    return;
                const data = yield response.json();
                if (!data)
                    return;
                // Record of: { 'address_0': price, 'address_1': price }
                this.coingeckoTokenPrices = Object.keys(coingecko_ids).reduce((prices, address) => {
                    var _a;
                    const tokenId = coingecko_ids[address];
                    prices[address] = ((_a = data[tokenId]) === null || _a === void 0 ? void 0 : _a.usd) || 0;
                    return prices;
                }, {});
            }
            catch (err) {
                console.log("Gecko API fail");
                this.coingeckoTokenPrices = {};
            }
        });
    }
    getCoingeckoTokenPrice(tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.coingeckoInitialized)
                this.coingeckoInitialized = this.getAllCoingeckoPrices();
            yield this.coingeckoInitialized;
            const geckoPrice = this.coingeckoTokenPrices[tokenAddress];
            return geckoPrice || 0;
        });
    }
    getDexscreenerTokenPrice(tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const chainId = dexscreener_ids[tokenAddress];
                const response = yield fetch("https://api.dexscreener.com/latest/dex/search?q=" + tokenAddress);
                if (response.status != 200)
                    return 0;
                const data = yield response.json();
                if (!data || !data.pairs || data.pairs.length === 0)
                    return 0;
                const pairs = data.pairs;
                const pairItem = pairs.filter((pair) => chainId.includes(pair.chainId) && (pair.baseToken.address.toLowerCase() == tokenAddress || pair.quoteToken.address.toLowerCase() == tokenAddress));
                return pairItem.length > 0 ? pairItem[0].priceUsd : 0;
            }
            catch (_a) {
                return 0;
            }
        });
    }
    getFantomTokenPrice(tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetch("https://eqapi-beta-8868m.ondigitalocean.app/fantom/v4/tokens");
                if (response.status != 200)
                    return 0;
                const data = yield response.json();
                if (!data || !data.data)
                    return 0;
                const priceData = data.data;
                const priceItem = Object.keys(priceData).filter((keyId) => keyId.toLowerCase() == tokenAddress);
                return priceItem.length > 0 ? Number(priceData[priceItem[0]].priceUsd) : 0;
            }
            catch (_a) {
                return 0;
            }
        });
    }
    initializeDebankTokenPrice(tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (Object.keys(fantom_ids).includes(tokenAddress.toLowerCase())) {
                const result = yield this.getFantomTokenPrice(tokenAddress);
                if (result)
                    return result;
            }
            if (Object.keys(dexscreener_ids).includes(tokenAddress.toLowerCase())) {
                const result = yield this.getDexscreenerTokenPrice(tokenAddress.toLowerCase());
                if (result)
                    return result;
            }
            if (Object.keys(coingecko_ids).includes(tokenAddress.toLowerCase())) {
                const result = yield this.getCoingeckoTokenPrice(tokenAddress.toLowerCase());
                if (result)
                    return result;
            }
            return 0;
        });
    }
    getDebankTokenPrice(tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (tokenAddress.toLowerCase() === '0xf28164a485b0b2c90639e47b0f377b4a438a16b1') { // fix for dQuick
                return (yield this.getDebankTokenPrice('0x831753dd7087cac61ab5644b308642cc1c33dc13')) * 1.68;
            }
            if (tokenAddress.toLowerCase() === '0x63468133ed352e602beb61dd254d6060ad2fe419') { // fix for sTHO
                return (yield this.getDebankTokenPrice('0xae4aa155d2987b454c29450ef4f862cf00907b61')) * 1.1;
            }
            if (tokenAddress.toLowerCase() === '0xfcef8a994209d6916eb2c86cdd2afd60aa6f54b1') { // fix for fBEETS
                return (yield this.getDebankTokenPrice('0xf24bcf4d1e507740041c9cfd2dddb29585adce1e')) * 0.93;
            }
            if (tokenAddress.toLowerCase() === '0x5979d7b546e38e414f7e9822514be443a4800529') { // TEMPORARY fix for WSTETH
                return (yield this.getDebankTokenPrice('0x82af49447d8a07e3bd95bd0d56f35241523fbab1')) / 0.92;
            }
            if (tokenAddress.toLowerCase() === '0x8e38179d361402f6a94767757e807146609e9b3d') { // TEMPORARY fix for DOLA on blast
                return 1;
            }
            if (tokenAddress.toLowerCase() === '0x3f56e0c36d275367b8c502090edf38289b3dea0d') { // TEMPORARY fix for MAI
                return 1;
            }
            if (tokenAddress.toLowerCase() === '0x2fc5cf65fd0a660801f119832b2158756968266d') { // TEMPORARY fix for CHI
                return 1;
            }
            if (tokenAddress.toLowerCase() === '0xc19669a405067927865b40ea045a2baabbbe57f5') { // TEMPORARY fix for STAR
                return 1;
            }
            if (tokenAddress.toLowerCase() === '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376') { // TEMPORARY fix for usd+
                return 1;
            }
            if (tokenAddress.toLowerCase() === '0xc518a88c67ceca8b3f24c4562cb71deeb2af86b7') { // TEMPORARY fix for re.al usdc
                return 1;
            }
            if (tokenAddress.toLowerCase() === '0xaec9e50e3397f9ddc635c6c429c8c7eca418a143') { // TEMPORARY fix for re.al arcUSD
                return 1;
            }
            if (tokenAddress.toLowerCase() === '0xc71aaf8e486e3f33841bb56ca3fd2ac3fa8d29a8') { // TEMPORARY fix for WSTETH Canto
                return (yield this.getDebankTokenPrice('0x5fd55a1b9fc24967c4db09c513c3ba0dfa7ff687')) * 1.12;
            }
            if (tokenAddress.toLowerCase() === '0x152b9d0fdc40c096757f570a51e494bd4b943e50') { // TEMPORARY fix for BTC.b AVAX
                return (yield this.getDebankTokenPrice('0x50b7545627a5162f82a992c33b87adc75187b218'));
            }
            if (tokenAddress.toLowerCase() === '0x9fc3104f6fc188fee65c85bbc4b94a48282ae76d') { // TEMPORARY fix for SATIN
                return 0;
            }
            if ([
                "0x9c67ee39e3c4954396b9142010653f17257dd39c",
                "0x7b35ce522cb72e4077baeb96cb923a5529764a00",
                "0xea6887e4a9cda1b77e70129e5fba830cdb5cddef",
                "0x60bb3d364b765c497c8ce50ae0ae3f0882c5bd05",
                "0x900f1ec5819fa087d368877cd03b265bf1802667",
                "0xea38f1ccf77bf43f352636241b05dd8f6f5f52b2"
            ].includes(tokenAddress.toLowerCase())) { // fix for IMX
                return 0;
            }
            if (tokenAddress.toLowerCase() === '0xda0053f0befcbcac208a3f867bb243716734d809') { // TEMPORARY fix for oxSOLID
                return (yield this.getDebankTokenPrice('0x888ef71766ca594ded1f0fa3ae64ed2941740a20')) * 0.88;
            }
            if (tokenAddress.toLowerCase() === '0x431d5dff03120afa4bdf332c61a6e1766ef37bdb') { // TEMPORARY fix for JPYCv2
                return (yield this.getDebankTokenPrice('0x6ae7dfc73e0dde2aa99ac063dcf7e8a63265108c'));
            }
            if (!this.debankTokensPrice[tokenAddress])
                this.debankTokensPrice[tokenAddress] = this.initializeDebankTokenPrice(tokenAddress);
            const tokenPrice = yield this.debankTokensPrice[tokenAddress];
            if (tokenPrice === 0) {
                //manual fallback
                if (tokenAddress.toLowerCase() === '0xaaa6c1e32c55a7bfa8066a6fae9b42650f262418') { // fix for RAM
                    return 0.02;
                }
                if (tokenAddress.toLowerCase() === '0xd5954c3084a1ccd70b4da011e67760b8e78aee84') { // fix for ARX
                    return 0.5;
                }
                if (tokenAddress.toLowerCase() === '0xe80772eaf6e2e18b651f160bc9158b2a5cafca65') { // fix for USD+
                    return 1;
                }
                if (tokenAddress.toLowerCase() === '0x3712871408a829c5cd4e86da1f4ce727efcd28f6') { // fix for GLCR
                    return 0.011;
                }
                if (tokenAddress.toLowerCase() === '0x5756a28e2aae01f600fc2c01358395f5c1f8ad3a') { // fix for VS
                    return 0.05;
                }
                if (tokenAddress.toLowerCase() === '0x160e07e42adbc1fce92d505b579bcd8a3fbea77d') { // fix for FANG
                    return 0.1;
                }
                if (tokenAddress.toLowerCase() === '0x1c28edf9e0d66f3124f141a3cf3ef1217f7019c4') { // fix for SLNA
                    return 0.00045;
                }
                // try fallback on offchain
                const subgraphTokensPrice = yield this.getSubgraphTokensPrice();
                const subgraphTokenPrice = subgraphTokensPrice[tokenAddress];
                return subgraphTokenPrice ? subgraphTokenPrice : 0;
            }
            return tokenPrice;
        });
    }
}
exports.default = OffchainPriceHelper;
